const Insight = Object.freeze({
  ATTRIBUTE: 'Attribute',
  EMOTION: 'Emotion',
  BEHAVIOR: 'Behavior'
})
export default Insight
// RESERVE BELOW
